import React, { useEffect } from "react";
import useTypeDecription from "../../../hooks/useTypeDecription";
import BarcodeWrapper from "./BarcodeWrapper";
import { useSelector } from "react-redux";

export default function barcodePage() {
  const lang = useSelector((state) => state.changeLang.language.stepTwo.barcode);
  const { content, getContent } = useTypeDecription();

  useEffect(() => {
    getContent("barcode");
  }, []);

  return <BarcodeWrapper popoverText={lang[0]}>{content}</BarcodeWrapper>;
}
